import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Shield, ChevronDown } from "lucide-react";

export const INFO_LINKS = [
  { label: "About us", slug: "about-us" },
  { label: "Case studies", slug: "case-studies" },
  { label: "Privacy policy", slug: "privacy-policy" },
  { label: "Pricing and experience", slug: "pricing-and-experience" },
  { label: "Security policy", slug: "security-policy" },
];

export function SiteFooter() {
  const nav = useNavigate();
  return (
    <footer className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-10">
        <div className="flex flex-col md:flex-row md:items-start justify-between gap-10">
          <div className="flex flex-col gap-4">
            <button onClick={() => { window.scrollTo({ top: 0, behavior: "smooth" }); nav("/"); }} data-testid="footer-home-btn"
              className="flex items-center gap-2 hover:opacity-80 transition-opacity w-fit">
              <div className="w-7 h-7 rounded-sm bg-white flex items-center justify-center"><Shield className="w-4 h-4 text-black" /></div>
              <span className="font-display font-extrabold text-lg tracking-tight text-white">TARDIGRADE</span>
            </button>
            <a href="mailto:support@tardigradeteam.com" data-testid="footer-contact-link" className="text-[#C9CDD2] hover:text-white transition-colors w-fit" style={{ fontSize: "16px" }}>Contact us</a>
          </div>
          <UsefulInfo />
        </div>
      </div>
    </footer>
  );
}

function UsefulInfo() {
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  return (
    <div className="min-w-[180px]" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
      <button data-testid="footer-useful-info-toggle" onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-2 text-[#D6D9DD] hover:text-white transition-colors font-display font-bold" style={{ fontSize: "17px" }}>
        Useful info <ChevronDown className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <ul data-testid="footer-useful-info-list" className="mt-3 space-y-2 fade-up">
          {INFO_LINKS.map((l) => (
            <li key={l.slug}>
              <button data-testid={`footer-info-${l.slug}`} onClick={() => { window.scrollTo({ top: 0 }); nav(`/info/${l.slug}`); }}
                className="text-[#C9CDD2] hover:text-white transition-colors text-left" style={{ fontSize: "16px" }}>{l.label}</button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
